<template>
  <div class="login">
    <div class="wrapper">
      <div class="logo-wrapper">
        <img
          src="/images/logo.svg"
          class="logo-wrapper__image"
          alt="logo"
        >
      </div>
      <form
        class="form"
        @submit.prevent="onSubmit"
      >
        <p class="form__title h3">Вход в аккаунт</p>
        <BaseInput
          v-model="username"
          class="form__input"
          placeholder="Логин"
        />
        <BaseInput
          v-model="password"
          class="form__input"
          type="password"
          placeholder="Пароль"
        />
        <div class="forgot">
          <RouterLink to="/forgot" class="forgot__link">Забыли пароль?</RouterLink>
        </div>
        <BaseButton
          block
          :loading="loading"
          class="form__button"
        >ВОЙТИ</BaseButton>

        <InvalidFeedback v-if="error" style="margin-top: 8px;">
          {{ error }}
        </InvalidFeedback>
      </form>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'
import InvalidFeedback from '@/components/InvalidFeedback'

export default {
  name: 'login',
  components: {
    BaseButton,
    BaseInput,
    InvalidFeedback
  },
  data () {
    return {
      loading: false,
      username: '',
      password: '',
      error: ''
    }
  },
  methods: {
    async onSubmit () {
      try {
        this.error = ''
        this.loading = true

        await this.$store.dispatch('auth/logIn', {
          username: this.username,
          password: this.password
        })
      } catch (e) {
        if (e.response.status === 401) {
          this.error = 'Вход не удался. Неправильный логин или пароль.'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .wrapper {
    width: 440px;
  }

  .logo-wrapper {
    &__image {
      display: block;
      width: 229px;
    }
  }

  .form {
    margin-top: 20px;
    background: #1D1D1D;
    border-radius: 30px;
    padding: 28px;

    .forgot {
      text-align: right;
      margin-bottom: 58px;

      &__link {
        text-decoration: none;
        color: $brand-color;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    &__title {
      text-align: center;
      margin-bottom: 30px;
    }

    &__input {
      margin-bottom: 14px;
      height: 55px;
    }

    &__button {
      height: 60px;
    }
  }
}
</style>
